import { isAxiosError } from 'axios';

interface ApiErrorBody {
  error?: unknown;
  detail?: unknown;
  jobId?: unknown;
}

function errorBody(e: unknown): ApiErrorBody | undefined {
  if (!isAxiosError(e)) return undefined;
  const data: unknown = e.response?.data;
  return data && typeof data === 'object' ? (data as ApiErrorBody) : undefined;
}

export function apiErrorMessage(e: unknown, fallback: string): string {
  const body = errorBody(e);
  if (typeof body?.error === 'string' && body.error.trim()) return body.error;
  if (typeof body?.detail === 'string' && body.detail.trim()) return body.detail;
  if (isAxiosError(e)) return e.response ? fallback : e.message || fallback;
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export function conflictJobId(e: unknown): string | undefined {
  if (!isAxiosError(e) || e.response?.status !== 409) return undefined;
  const jobId = errorBody(e)?.jobId;
  return typeof jobId === 'string' && jobId ? jobId : undefined;
}
